// store.js
import {combineReducers} from 'redux';
import {persistReducer, persistStore} from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import {configureStore} from "@reduxjs/toolkit";

// Initial state for session storage input data
const initialSessionState = {
    // [Keys.store_Dash_HomeTab_TabLayout_SelectedTabName]: Modules.RecentResources,
    // [Keys.store_Dash_HomeTab_TabLayout_SelectedTabIndex]: 0,
};

// Reducer for session storage input data
const sessionReducer = (state = initialSessionState, action) => {
    // switch (action.type) {
    //     case Keys.store_Dash_searchInputValue:
    //         return {
    //             ...state,
    //             [action.type]: action.payload,
    //         };
    //     default:
    //         return state;
    // }
    return {
        ...state,
        [action.type]: action.payload,
    };
};

// Create a custom session storage object
const createSessionStorage = createWebStorage('session');

// Configure Redux Persist for session storage
const sessionPersistConfig = {
    key: 'session',
    storage: createSessionStorage,
    whitelist: ['sessionStore'], // Reducer keys to persist
};

// Create a persisted reducer for session storage
const persistedSessionReducer = persistReducer(sessionPersistConfig, sessionReducer);

// Combine reducers
const rootReducer = combineReducers({
    sessionStore: persistedSessionReducer,
});

// Create the Redux store
// const store = createStore(rootReducer);
const store = configureStore({
    reducer: rootReducer,
});
// Create a persisted store for session storage
const sessionPersistor = persistStore(store);

export {store, sessionPersistor};
